import { ISelectOption } from '@lib/ui/form-elements';
// noinspection ES6PreferShortImport // Should use this import to prevent circular dependencies
import { EGenderDTO, getGenderLocalization } from '../view-models/consts/gender';
import { EProfileTagsStringDTO, getProfileTagsTranslations } from '../view-models/consts/profile-tags';

const BRAZILIAN_UFS = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
];

export namespace SharedFormOptions {
  export const genderOptions: () => ISelectOption[] = () => [
    { label: getGenderLocalization(EGenderDTO.Female), value: EGenderDTO.Female },
    { label: getGenderLocalization(EGenderDTO.Male), value: EGenderDTO.Male },
  ];

  export const ufOptions: () => ISelectOption[] = () => BRAZILIAN_UFS.map((uf) => ({ label: uf, value: uf }));

  export const groupsOptions: () => ISelectOption[] = () =>
    Object.values(EProfileTagsStringDTO)
      .filter((v) => v !== EProfileTagsStringDTO.None)
      .map((v) => ({
        label: getProfileTagsTranslations(v) ?? v,
        value: v,
      }));
}
